export default function ProductQuantity() {
    const productQuantityControls =
        document.querySelectorAll('.product-quantity');

    if (!productQuantityControls.length) return;

    productQuantityControls.forEach(control => {
        const decreaseBtn = control.querySelector('[data-direction="down"]');
        const increaseBtn = control.querySelector('[data-direction="up"]');
        const input = control.querySelector('input');

        if (!decreaseBtn || !increaseBtn || !input) return;

        decreaseBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value);
            if (currentValue > 1) {
                input.value = currentValue - 1;
            }
        });

        increaseBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value);
            input.value = currentValue + 1;
        });

        input.addEventListener('change', () => {
            let currentValue = parseInt(input.value);
            if (isNaN(currentValue) || currentValue < 1) {
                input.value = 1;
            }
        });
    });
}
